import { Component, Inject, isDevMode, OnInit, PLATFORM_ID, HostListener } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router'
import { isPlatformBrowser, Location, PopStateEvent, DOCUMENT } from '@angular/common'

import { Store, select } from '@ngrx/store';

import { TenantService } from './shared/services/tenant.service';
import { AnalyticsService } from './shared/services/analytics.service';

import * as fromBase from './base/reducers'

import * as preferences from './base/actions/preferences.actions'


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app'
  lastScrollTop = 0;
  lastPoppedUrl: string
  yScrollStack: number[] = []

  constructor(
    private router: Router,
    private location: Location,
    public tenantSvc: TenantService,
    private analyticsSvc: AnalyticsService,
    @Inject(PLATFORM_ID) private platformId: string,
    private store: Store<any>,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit() {

    // on scroll
    //window.addEventListener('scroll', this.onScroll, true);

    if(isPlatformBrowser(this.platformId)) {
      this.location.subscribe((ev:PopStateEvent) =>
        this.lastPoppedUrl = ev.url)

      this.router.events.subscribe((ev:NavigationStart | NavigationEnd) => {
          if (ev instanceof NavigationStart && ev.url !== this.lastPoppedUrl)
            this.yScrollStack.push(window.scrollY)

        if (ev instanceof NavigationEnd) {
              if (ev.url === this.lastPoppedUrl) {
                  this.lastPoppedUrl = null
                  window.scrollTo(0, this.yScrollStack.pop())
              } else if (ev.url.indexOf('/checkout') > -1) {
                window.scrollTo(0, 0)
              }
          }
      })
    }

    // Is mega menu open?
    this.store.pipe(
      select(fromBase.isMegaMenuOpen)
    ).subscribe((isMegaMenuOpen) => {
      const overlay = document.getElementById('overlay')

      if (isMegaMenuOpen) {
        overlay.classList.add('overlay-active')
      } else {
        overlay.classList.remove('overlay-active')
      }
    })

    this.store.dispatch(new preferences.GetTenantPreferences())
  }

  onCssError() {
    this.tenantSvc.removeGlobalLoader()
  }

  onCssSuccess() {
    this.tenantSvc.removeGlobalLoader()
  }

  @HostListener('window:scroll')
  onWindowScroll() {

    let distanceToTop = window.pageYOffset || document.documentElement.scrollTop;
    const body = document.getElementsByTagName('body')[0];

    if (distanceToTop > this.lastScrollTop) {
      if (distanceToTop > 100) {
          body.classList.add("scroll-mode-enabled");
        }
    } else {
        // upscroll code
        body.classList.remove("scroll-mode-enabled");
    }
    this.lastScrollTop = distanceToTop;

  }



}
